<div class="error-config-page">
  <div class="error-card">

    <div class="status-icon" aria-hidden="true">
      <i class="pi pi-exclamation-triangle"></i>
    </div>

    <h1 class="title">Tenemos problemas para conectarnos</h1>
    <p class="description">
      No pudimos cargar la configuración inicial del sistema.
      Revisa la conexión con el backend.<br>
      El sistema reintenta automáticamente cada 15 segundos.
    </p>

    <div class="loading-row" aria-label="Esperando conexión con el backend">
      <span class="spinner" aria-hidden="true"></span>
      <span class="loading-text">
        Esperando conexión con el backend
        <span class="dots"></span>
        @if (countdown() > 0) {
          <span class="countdown">({{ countdown() }}s)</span>
        }
      </span>
    </div>

    <div class="error-icon" aria-hidden="true">
      <i class="pi pi-wifi"></i>
    </div>

  </div>
</div>
